/** Notification live queries. */

import { COL } from '../../collections';
import { where, orderBy, limit } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { NotificationDoc } from '../../types';

export function useNotifications(userId: string | null) {
  return useLiveQuery<NotificationDoc>(
    userId ? COL.notifications : null,
    userId ? [where('userId', '==', userId), orderBy('createdAt', 'desc'), limit(50)] : [],
    Boolean(userId),
  );
}
